import React from 'react';
import "./accBanner.scss";

const AccBanner = () => {
  return (
    <div id="scrollTop" className='acc-banner'>
        <p>ACCOMPLISHMENTS</p>
        
    </div>
  )
}

export default AccBanner;